import { useMemo } from "react"

const usePortalyLink = (slug, page = '') => useMemo(() => process.env.NODE_ENV === 'development' && typeof window !== 'undefined'
  ? `${location.origin}/${slug}${page}`
  : `https://${process.env.NEXT_PUBLIC_URL ?? process.env.NEXT_PUBLIC_VERCEL_URL}/${slug}${page}`, [slug, page])

export default usePortalyLink
